// Tone Learning Units Data
// This file contains data for tone learning units and voice characteristics study

export const toneLearningUnits = [
  {
    id: 'tone_unit_1',
    unitNumber: 1,
    title: {
      traditional: '基礎語調學習',
      simplified: '基础语调学习',
      english: 'Basic Tone Learning'
    },
    description: {
      traditional: '學習英語的基本語調模式和重音規則',
      simplified: '学习英语的基本语调模式和重音规则',
      english: 'Learn basic English intonation patterns and stress rules'
    },
    icon: '🎵',
    difficulty: 'beginner',
    duration: '15-20 mins',
    totalLessons: 4,
    completedLessons: 0,
    progress: 0,
    isUnlocked: true,
    isCompleted: false,
    topics: [
      'Rising and falling intonation',
      'Word stress patterns',
      'Sentence stress',
      'Basic rhythm'
    ],
    targetSkills: [
      'Recognize basic intonation patterns',
      'Apply correct word stress',
      'Use appropriate sentence stress',
      'Maintain natural rhythm'
    ]
  },
  {
    id: 'tone_unit_2',
    unitNumber: 2,
    title: {
      traditional: '情感語調表達',
      simplified: '情感语调表达',
      english: 'Emotional Tone Expression'
    },
    description: {
      traditional: '掌握表達不同情感的語調技巧',
      simplified: '掌握表达不同情感的语调技巧',
      english: 'Master tone techniques for expressing different emotions'
    },
    icon: '😊',
    difficulty: 'beginner',
    duration: '20-25 mins',
    totalLessons: 5,
    completedLessons: 0,
    progress: 0,
    isUnlocked: true,
    isCompleted: false,
    topics: [
      'Happy and cheerful tones',
      'Serious and formal tones',
      'Excited and enthusiastic tones',
      'Calm and soothing tones',
      'Confident and assertive tones'
    ],
    targetSkills: [
      'Express happiness and joy',
      'Maintain formal communication',
      'Show enthusiasm and excitement',
      'Create calm and peaceful atmosphere',
      'Project confidence and authority'
    ]
  },
  {
    id: 'tone_unit_3',
    unitNumber: 3,
    title: {
      traditional: '美式語調特色',
      simplified: '美式语调特色',
      english: 'American Tone Characteristics'
    },
    description: {
      traditional: '深入學習美式英語的語調特色和發音特點',
      simplified: '深入学习美式英语的语调特色和发音特点',
      english: 'Deep dive into American English tone characteristics and pronunciation features'
    },
    icon: '🇺🇸',
    difficulty: 'intermediate',
    duration: '25-30 mins',
    totalLessons: 6,
    completedLessons: 0,
    progress: 0,
    isUnlocked: false,
    isCompleted: false,
    topics: [
      'American accent patterns',
      'Rhotic pronunciation',
      'Flap T sounds',
      'Vowel modifications',
      'Linking and blending',
      'American intonation patterns'
    ],
    targetSkills: [
      'Master American accent features',
      'Use rhotic pronunciation correctly',
      'Apply flap T in appropriate contexts',
      'Modify vowels naturally',
      'Link words smoothly',
      'Follow American intonation'
    ]
  },
  {
    id: 'tone_unit_4',
    unitNumber: 4,
    title: {
      traditional: '英式語調優雅',
      simplified: '英式语调优雅',
      english: 'British Tone Elegance'
    },
    description: {
      traditional: '學習優雅的英式語調和發音技巧',
      simplified: '学习优雅的英式语调和发音技巧',
      english: 'Learn elegant British tone and pronunciation techniques'
    },
    icon: '🇬🇧',
    difficulty: 'intermediate',
    duration: '25-30 mins',
    totalLessons: 6,
    completedLessons: 0,
    progress: 0,
    isUnlocked: false,
    isCompleted: false,
    topics: [
      'Received Pronunciation (RP)',
      'Non-rhotic pronunciation',
      'British vowel sounds',
      'Polite intonation patterns',
      'Formal speech patterns',
      'British rhythm and flow'
    ],
    targetSkills: [
      'Use Received Pronunciation',
      'Apply non-rhotic pronunciation',
      'Master British vowel sounds',
      'Maintain polite intonation',
      'Speak formally when needed',
      'Follow British rhythm'
    ]
  },
  {
    id: 'tone_unit_5',
    unitNumber: 5,
    title: {
      traditional: '澳洲語調活力',
      simplified: '澳洲语调活力',
      english: 'Australian Tone Energy'
    },
    description: {
      traditional: '掌握充滿活力的澳洲英語語調',
      simplified: '掌握充满活力的澳洲英语语调',
      english: 'Master the energetic Australian English tone'
    },
    icon: '🇦🇺',
    difficulty: 'intermediate',
    duration: '20-25 mins',
    totalLessons: 5,
    completedLessons: 0,
    progress: 0,
    isUnlocked: false,
    isCompleted: false,
    topics: [
      'Australian accent features',
      'Rising intonation patterns',
      'Casual and friendly tones',
      'Australian slang intonation',
      'Outback speech patterns'
    ],
    targetSkills: [
      'Use Australian accent features',
      'Apply rising intonation naturally',
      'Maintain casual and friendly tone',
      'Incorporate Australian expressions',
      'Sound natural in casual settings'
    ]
  },
  {
    id: 'tone_unit_6',
    unitNumber: 6,
    title: {
      traditional: '德式語調精確',
      simplified: '德式语调精确',
      english: 'German Tone Precision'
    },
    description: {
      traditional: '學習精確清晰的德式英語語調',
      simplified: '学习精确清晰的德式英语语调',
      english: 'Learn precise and clear German-accented English tone'
    },
    icon: '🇩🇪',
    difficulty: 'advanced',
    duration: '30-35 mins',
    totalLessons: 7,
    completedLessons: 0,
    progress: 0,
    isUnlocked: false,
    isCompleted: false,
    topics: [
      'German accent characteristics',
      'Precise pronunciation patterns',
      'Clear articulation techniques',
      'Logical speech structure',
      'Professional communication tone',
      'Technical vocabulary intonation',
      'Formal presentation skills'
    ],
    targetSkills: [
      'Maintain German accent features',
      'Pronounce words precisely',
      'Articulate clearly and distinctly',
      'Structure speech logically',
      'Communicate professionally',
      'Handle technical vocabulary',
      'Present formally and clearly'
    ]
  },
  {
    id: 'tone_unit_7',
    unitNumber: 7,
    title: {
      traditional: '印度語調溫暖',
      simplified: '印度语调温暖',
      english: 'Indian Tone Warmth'
    },
    description: {
      traditional: '掌握溫暖友善的印度英語語調',
      simplified: '掌握温暖友善的印度英语语调',
      english: 'Master the warm and friendly Indian English tone'
    },
    icon: '🇮🇳',
    difficulty: 'intermediate',
    duration: '25-30 mins',
    totalLessons: 6,
    completedLessons: 0,
    progress: 0,
    isUnlocked: false,
    isCompleted: false,
    topics: [
      'Indian accent patterns',
      'Melodic intonation',
      'Patient and helpful tones',
      'Cultural communication styles',
      'Respectful speech patterns',
      'Warm hospitality expressions'
    ],
    targetSkills: [
      'Use Indian accent features',
      'Apply melodic intonation',
      'Maintain patient and helpful tone',
      'Communicate with cultural sensitivity',
      'Show respect in speech',
      'Express warm hospitality'
    ]
  },
  {
    id: 'tone_unit_8',
    unitNumber: 8,
    title: {
      traditional: '語調綜合應用',
      simplified: '语调综合应用',
      english: 'Tone Integration Mastery'
    },
    description: {
      traditional: '綜合運用各種語調技巧進行自然流暢的交流',
      simplified: '综合运用各种语调技巧进行自然流畅的交流',
      english: 'Integrate various tone techniques for natural and fluent communication'
    },
    icon: '🎯',
    difficulty: 'advanced',
    duration: '35-40 mins',
    totalLessons: 8,
    completedLessons: 0,
    progress: 0,
    isUnlocked: false,
    isCompleted: false,
    topics: [
      'Tone switching techniques',
      'Context-appropriate intonation',
      'Emotional intelligence in speech',
      'Cross-cultural communication',
      'Professional presentation skills',
      'Casual conversation mastery',
      'Public speaking confidence',
      'Personal voice development'
    ],
    targetSkills: [
      'Switch tones appropriately',
      'Use context-appropriate intonation',
      'Apply emotional intelligence',
      'Communicate across cultures',
      'Present professionally',
      'Master casual conversations',
      'Speak with confidence',
      'Develop personal voice style'
    ]
  }
];

export const toneLearningLessons = [
  // Unit 1 Lessons
  {
    id: 'lesson_1_1',
    unitId: 'tone_unit_1',
    lessonNumber: 1,
    title: {
      traditional: '上升和下降語調',
      simplified: '上升和下降语调',
      english: 'Rising and Falling Intonation'
    },
    type: 'theory',
    typeIcon: '📚',
    duration: '5 mins',
    difficulty: 'beginner',
    isCompleted: false,
    isUnlocked: true,
    content: {
      theory: {
        traditional: '學習英語中上升語調和下降語調的基本規則和應用場景',
        simplified: '学习英语中上升语调和下降语调的基本规则和应用场景',
        english: 'Learn the basic rules and application scenarios of rising and falling intonation in English'
      },
      examples: [
        'Rising intonation for questions',
        'Falling intonation for statements',
        'Mixed patterns for complex sentences'
      ],
      practice: [
        'Practice question intonation',
        'Practice statement intonation',
        'Record and compare your speech'
      ]
    }
  },
  {
    id: 'lesson_1_2',
    unitId: 'tone_unit_1',
    lessonNumber: 2,
    title: {
      traditional: '單詞重音模式',
      simplified: '单词重音模式',
      english: 'Word Stress Patterns'
    },
    type: 'practice',
    typeIcon: '🎤',
    duration: '8 mins',
    difficulty: 'beginner',
    isCompleted: false,
    isUnlocked: true,
    content: {
      theory: {
        traditional: '掌握英語單詞的重音規則和發音技巧',
        simplified: '掌握英语单词的重音规则和发音技巧',
        english: 'Master English word stress rules and pronunciation techniques'
      },
      examples: [
        'Two-syllable word stress',
        'Three-syllable word stress',
        'Compound word stress',
        'Prefix and suffix stress'
      ],
      practice: [
        'Practice stress patterns',
        'Listen and repeat exercises',
        'Stress identification games'
      ]
    }
  },
  {
    id: 'lesson_1_3',
    unitId: 'tone_unit_1',
    lessonNumber: 3,
    title: {
      traditional: '句子重音技巧',
      simplified: '句子重音技巧',
      english: 'Sentence Stress Techniques'
    },
    type: 'interactive',
    typeIcon: '🎭',
    duration: '10 mins',
    difficulty: 'beginner',
    isCompleted: false,
    isUnlocked: true,
    content: {
      theory: {
        traditional: '學習如何在句子中正確使用重音來強調重要信息',
        simplified: '学习如何在句子中正确使用重音来强调重要信息',
        english: 'Learn how to use stress correctly in sentences to emphasize important information'
      },
      examples: [
        'Content words vs function words',
        'Emphasis on key information',
        'Contrastive stress',
        'Emotional stress'
      ],
      practice: [
        'Identify stressed words',
        'Practice emphasis techniques',
        'Role-play conversations'
      ]
    }
  },
  {
    id: 'lesson_1_4',
    unitId: 'tone_unit_1',
    lessonNumber: 4,
    title: {
      traditional: '基本節奏掌握',
      simplified: '基本节奏掌握',
      english: 'Basic Rhythm Mastery'
    },
    type: 'test',
    typeIcon: '📝',
    duration: '12 mins',
    difficulty: 'beginner',
    isCompleted: false,
    isUnlocked: true,
    content: {
      theory: {
        traditional: '掌握英語的基本節奏模式和語流技巧',
        simplified: '掌握英语的基本节奏模式和语流技巧',
        english: 'Master basic English rhythm patterns and flow techniques'
      },
      examples: [
        'Syllable-timed vs stress-timed',
        'Rhythm in connected speech',
        'Pausing and phrasing',
        'Natural speech flow'
      ],
      practice: [
        'Rhythm exercises',
        'Connected speech practice',
        'Timing and pacing drills',
        'Final assessment'
      ]
    }
  }
];

// Helper functions
export const getToneLearningUnits = () => toneLearningUnits;

export const getToneLearningUnitById = (unitId) => {
  return toneLearningUnits.find(unit => unit.id === unitId);
};

export const getLessonsByUnitId = (unitId) => {
  return toneLearningLessons.filter(lesson => lesson.unitId === unitId);
};

export const getLessonById = (lessonId) => {
  return toneLearningLessons.find(lesson => lesson.id === lessonId);
};

export const calculateUnitProgress = (unitId) => {
  const unit = getToneLearningUnitById(unitId);
  const lessons = getLessonsByUnitId(unitId);
  const completedLessons = lessons.filter(lesson => lesson.isCompleted).length;
  const progress = lessons.length > 0 ? (completedLessons / lessons.length) * 100 : 0;
  
  return {
    completedLessons,
    totalLessons: lessons.length,
    progress: Math.round(progress)
  };
};

export const unlockNextUnit = (currentUnitId) => {
  const currentUnit = getToneLearningUnitById(currentUnitId);
  if (currentUnit && currentUnit.isCompleted) {
    const nextUnit = toneLearningUnits.find(unit => unit.unitNumber === currentUnit.unitNumber + 1);
    if (nextUnit) {
      nextUnit.isUnlocked = true;
    }
  }
};

export const completeLesson = (lessonId) => {
  const lesson = getLessonById(lessonId);
  if (lesson) {
    lesson.isCompleted = true;
    
    // Check if all lessons in unit are completed
    const unitLessons = getLessonsByUnitId(lesson.unitId);
    const allCompleted = unitLessons.every(l => l.isCompleted);
    
    if (allCompleted) {
      const unit = getToneLearningUnitById(lesson.unitId);
      if (unit) {
        unit.isCompleted = true;
        unlockNextUnit(lesson.unitId);
      }
    }
  }
};
